import type { StudentSample } from "./types";

export function hasUsableProviderTranscript(
  sample: Pick<StudentSample, "draft_candidates"> | null,
) {
  return Boolean(sample?.draft_candidates?.some((candidate) => candidate.transcript?.trim()));
}
